export enum FWStatusLabel {
  SYNCED = 'Synced',
  NOT_SYNCED = 'Not synced',
  NEED_TO_SYNC = 'Need to sync',
}
